import {resolveEnvironment} from './environment';
const config=resolveEnvironment(window.location,window.QR_FLEX_CONFIG || {},{
    apiUrl:process.env.REACT_APP_API_URL,
    publicUrl:process.env.REACT_APP_PUBLIC_URL,
});
export const ENVIRONMENT=config.environment;
export const API_URL=config.apiUrl;
export const PUBLIC_URL=config.publicUrl;
export const APP_URL=config.appUrl;
export const buildFetchUrl=(id='')=>PUBLIC_URL+'f/'+encodeURIComponent(id);
export const buildAppUrl=(route='')=>APP_URL+'#/'+route.replace(/^\/+/, '');
